import { stateStreamRegistry } from 'rxbeach';

const startStateStreams = () => {
  stateStreamRegistry.startReducing();

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      stateStreamRegistry.stopReducing();
    });
  }
};

export default startStateStreams;
